import { ResponseGetMembership } from '../../app/ApiGen';
import { request } from '../../utils/request';

export type Response = ResponseGetMembership;

export const getOrganisationMember = async (organisationId: string, userId: string): Promise<Response> =>
  request<Response>(`/organisations/${organisationId}/memberships/${userId}`, { method: 'GET' });
